import { render, staticRenderFns } from "./PhoneStoreForm.vue?vue&type=template&id=2531fc72"
import script from "./PhoneStoreForm.vue?vue&type=script&lang=js"
export * from "./PhoneStoreForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports